const VARIANT_STYLES = {
  info: 'bg-primary text-primary-foreground',
  success: 'bg-green-600 text-white',
  error: 'bg-destructive text-white',
  warning: 'bg-amber-600 text-white',
} as const;

export function Banner({
  variant,
  children,
}: {
  variant: keyof typeof VARIANT_STYLES;
  children: React.ReactNode;
}) {
  return (
    <div className={`flex items-center gap-2 px-4 py-2 ${VARIANT_STYLES[variant]}`}>
      {children}
    </div>
  );
}
